var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4e015f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    r: 53,
    cx: 328,
    cy: 133
  }), /*#__PURE__*/React.createElement("circle", {
    r: 15,
    cx: 231,
    cy: 452
  }), /*#__PURE__*/React.createElement("circle", {
    r: 42,
    cx: 130,
    cy: 213
  }), /*#__PURE__*/React.createElement("circle", {
    r: 23,
    cx: 517,
    cy: 157
  }), /*#__PURE__*/React.createElement("circle", {
    r: 39,
    cx: 368,
    cy: 308
  }), /*#__PURE__*/React.createElement("circle", {
    r: 26,
    cx: 117,
    cy: 361
  }), /*#__PURE__*/React.createElement("circle", {
    r: 14,
    cx: 823,
    cy: 61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 24,
    cx: 368,
    cy: 462
  }), /*#__PURE__*/React.createElement("circle", {
    r: 30,
    cx: 816,
    cy: 222
  }), /*#__PURE__*/React.createElement("circle", {
    r: 51,
    cx: 212,
    cy: 85
  }), /*#__PURE__*/React.createElement("circle", {
    r: 29,
    cx: 705,
    cy: 228
  }), /*#__PURE__*/React.createElement("circle", {
    r: 48,
    cx: 601,
    cy: 397
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.7c3dd12e7ad6b6feb02c167dbe55cbff.svg";
export { ForwardRef as ReactComponent };